import { FauxTable, FauxTableRow } from "@components/FauxTable";
import { formatDate, isValidDate } from "@utils/dates";
import { dateColumn, genericColumn, primaryRelationshipColumn, selectColumn } from "./columnHelpers";

/**
 * Businesses in a property
 */
export const propertyBusinessesRelationship = {
    collapsible: true,
    title: 'Businesses',
    tint: 'business',
    type: 'table',
    columns: [
        primaryRelationshipColumn({endpoint: 'businesses'}),
        genericColumn({
            label: 'Unit',
            render: {
                show: (object, parentObject) => {
                    const unitId = object?.pivot?.property_unit_id;
                    if(!unitId) {
                        return null;
                    }

                    const foundUnit = parentObject.property_units?.find(unit => unit.id === unitId);

                    return foundUnit?.unit;
                },
            },
        }),
        genericColumn({
            label: 'History',
            render: {
                show: (object) => {
                    const isValidMovedInDate = isValidDate(object.pivot.date_entered);
                    const isValidMovedOutDate = isValidDate(object.pivot.date_left);
                    return (
                        <FauxTable>
                            <FauxTableRow title={'Moved In'} breakTitle={false}>
                                {isValidMovedInDate && (<time>{formatDate(object.pivot.date_entered)}</time>)}
                                {!isValidMovedInDate && (<>N/A</>)}
                            </FauxTableRow>
                            <FauxTableRow title={'Moved Out'} breakTitle={false}>
                                {isValidMovedOutDate && (<time>{formatDate(object.pivot.date_left)}</time>)}
                                {!isValidMovedOutDate && (<>N/A</>)}
                            </FauxTableRow>
                        </FauxTable>
                    );
                },
            },
        }),
    ],
};

export const propertyBusinessesRelationshipEdit = {
    collapsible: true,
    title: 'Businesses',
    tint: 'business',
    type: 'table',
    columns: [
        primaryRelationshipColumn({endpoint: 'businesses'}),
        selectColumn({
            label: 'Unit',
            column: 'pivot.property_unit_id',
            // todo: conditional rendering based on if property has units
            enabled: (row, object) => {
                return object?.property_units?.length > 0;
            },
            options: (row, object) => {
                return object?.property_units ?? [];
            },
        }),
        dateColumn({label: 'Moved In', column: 'pivot.date_entered'}),
        dateColumn({label: 'Moved Out', column: 'pivot.date_left'}),
    ],
};
